import React from "react";
import { Select } from "antd";

const { Option } = Select;

const ViewTypeSelector = ({
  value,
  onChange,
  style = { width: 120 },
  viewOptions = [
    { value: "Daily", label: "Daily" },
    { value: "Weekly", label: "Weekly" },
    { value: "Monthly", label: "Monthly" }
  ]
}) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      style={style}
    >
      {viewOptions.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};

export default ViewTypeSelector;
